export const dueInBase = {
  unit: 2,
  value: 7,
  enabled: false,
  edit: false,
};

export const moveToNextLevelInBase = {
  unit: 2,
  value: 7,
  enabled: false,
  edit: false,
};

export const numberOfRequiredUsersBase = {
  type: 1,
  value: 1,
  enabled: false,
  edit: false,
};

export const moveForwardConditionBase = {
  enabled: false,
  type: 1,
  value: null,
  statusList: [],
};

export const moveBackwardConditionBase = {
  enabled: false,
  type: 1,
  value: null,
  statusList: [],
};

export const reviewLevelInitialState = {
  dueIn: dueInBase,
  allowRollback: false,
  allowAdditionAndRemovalUser: false,
  allowSkipLevel: false,
  allowFileUpdate: false,
  allowFileRemoval: false,
  allowFileAddition: false,
  moveToNextLevelIn: moveToNextLevelInBase,
  numberOfRequiredUsers: numberOfRequiredUsersBase,
  moveForwardCondition: moveForwardConditionBase,
  moveBackwardCondition: moveBackwardConditionBase,
  selectedDirection: 1,
  allowSkipLevelBackward: false,
  allowSendTransmittals: false,
};

export const propertiesMenuItems = [{ id: 1, text: "Close" }];

export const maximumDurationList = [
  { id: 1, text: "hour(s)" },
  { id: 2, text: "day(s)" },
  { id: 3, text: "week(s)" },
  { id: 4, text: "month(s)" },
  { id: 5, text: "year(s)" },
];

export const userTypesList = [
  { id: 1, text: "user(s)" },
  // { id: 2, text: 'user(s) from a group' }
];

export const moveLevelConstraintList = [
  { id: 1, text: "all" },
  { id: 2, text: "minimum" },
];

export const numberOfRequiredUsersList = [
  { id: 1, text: "hour(s)" },
  { id: 2, text: "day(s)" },
  { id: 3, text: "week(s)" },
  { id: 4, text: "month(s)" },
  { id: 5, text: "year(s)" },
];

export const initialReviewFlowState = {
  _id: "",
  name: "Review Flow custom name",
  description: "",
};

export const reviewFlowPropertiesMenuItems = [{ id: 1, text: "Close" }];

export const reviewLevelBaseSettings = {
  dueIn: null,
  dueInUnit: 2,
  moveToNextLevelInUnit: 2,
  moveToNextLevelInValue: null,
  enableMoveToNextLevelIn: false,
  numberOfRequiredUsersValue: null,
};

export const entityData = {
  RESOURCE_TYPE_FILE: {
    name: "Files",
    value: "RESOURCE_TYPE_FILE",
  },
  RESOURCE_TYPE_ISSUE: {
    name: "Issues",
    value: "RESOURCE_TYPE_ISSUE",
  },
  dataSource: [
    {
      name: "Files",
      value: "RESOURCE_TYPE_FILE",
    },
    {
      name: "Issues",
      value: "RESOURCE_TYPE_ISSUE",
    },
  ],
};

export const requireMandatoryCommentDataSource = [
  { value: 1, name: "Mark as Reviewed" },
  { value: 2, name: "Skip" },
  { value: 3, name: "Revoke" },
  { value: 4, name: "Change Status" },
];
